import React, { useState, useEffect } from "react";
import validator from "validator";
import axios from "axios";
import { useAuth } from "../contexts/auth";
import { postCustomersURL } from "../utils/api";
import {
    Flex,
    Spacer,
    Button,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    FormControl,
    FormLabel,
    FormErrorMessage,
    FormHelperText,
    Input,
    Text,
    RadioGroup,
    Radio,
    HStack,
    Box,
    InputRightElement,
    Switch,
  } from "@chakra-ui/react";

function CreateCustomer({
    isOpen,
    onClose,
    successCallback,
}) {

    const [ isCompany, setIsCompany ] = useState(false);

    const [ firstName, setFirstName ] = useState('');
    const [ lastName, setLastName ] = useState('');
    const [ mobile, setMobile ] = useState('');
    const [ gender, setGender ] = useState('Male');
    const [ email, setEmail ] = useState('');
    const [ password, setPassword ] = useState('');
    const [ companyName, setCompanyName ] = useState(null);
    const [ companyNumber, setCompanyNumber ] = useState(null);
    const [ companyAddress, setCompanyAddress ] = useState(null);
    const [ companyTin, setCompanyTin ] = useState(null);

    const [ invFirstName, setInvFirstName ] = useState(null);
    const [ invLastName, setInvLastName ] = useState(null);
    const [ invMobile, setInvMobile ] = useState(null);
    const [ invEmail, setInvEmail ] = useState(null);
    const [ invPassword, setInvPassword ] = useState(null);
    const [ invCompanyName, setInvCompanyName ] = useState(null);
    const [ invCompanyNumber, setInvCompanyNumber ] = useState(null);
    const [ invCompanyAddress, setInvCompanyAddress ] = useState(null);
    const [ invCompanyTin, setInvCompanyTin ] = useState(null);

    const { auth } = useAuth();
    const [ errors, setErrors ] = useState([]);
    const [ submitting, setSubmitting ] = useState(false);

    const postCustomers = (e) => {
        e.preventDefault();

        setSubmitting(true);
        // console.log(email, password);
        axios.post(postCustomersURL, {
            email,
            password,
            firstName,
            lastName,
            gender,
            mobile,
            companyName: companyName ? companyName : undefined, 
            companyNumber: companyNumber ? companyNumber : undefined,
            companyAddress: companyAddress ? companyAddress : undefined,
            companyTin: companyTin ? companyTin : undefined,
        },{
            headers: {
                Authorization: `Bearer ${auth.authToken}`
            }
        }).then(result => {
            if (result.status === 200) {
                // const roles = result.data.data.user.roles;
                const user = result.data.data;
                // console.log(user);
                if (successCallback) {
                    successCallback();
                }
                setFirstName('');
                setLastName('');
                setEmail('');
                setMobile('');
                setPassword('');
                setIsCompany(false);
                onClose();
            } else {
                setErrors(result.data.errors);
            }
        }).catch(e => {
            if (e.response === undefined) {
                setErrors(['Could not connect to server!'])
            } else {
                setErrors(e.response.data.errors)
            }
        }).finally(e => {
            setSubmitting(false);
        });
    }

    useEffect(() => {

        if (isCompany) {
            if (companyName != null && !validator.isEmpty(companyName)) {
                setInvCompanyName(companyName.length < 1);
            }
            if (companyNumber != null && !validator.isEmpty(companyNumber)) {
                setInvCompanyNumber(!validator.isNumeric(companyNumber));
            }
            if (companyAddress != null && !validator.isEmpty(companyAddress)) {
                setInvCompanyAddress(companyAddress.length < 1);
            }
            if (companyTin != null && !validator.isEmpty(companyTin)) {
                setInvCompanyTin(companyTin.length < 1);
            }
        }

        if (!validator.isEmpty(email)) {
            setInvEmail(!validator.isEmail(email));
        }

        if (!validator.isEmpty(password)) {
            setInvPassword(password.length <= 8);
        }

        if (!validator.isEmpty(firstName)) {
            setInvFirstName(firstName.length < 1);
        }

        if (!validator.isEmpty(lastName)) {
            setInvLastName(lastName.length < 1);
        }

        if (!validator.isEmpty(mobile)) {
            setInvMobile(!validator.isNumeric(mobile));
        }


    }, [firstName, lastName, email, password, mobile, companyName, companyNumber, companyAddress, companyTin]);

    const resetCompanyInputsAndErrors = () => {
        setCompanyName(null);
        setCompanyNumber(null);
        setCompanyAddress(null);
        setCompanyTin(null);
        setInvCompanyName(null);
        setInvCompanyNumber(null);
        setInvCompanyAddress(null);
        setInvCompanyTin(null);
    }

    useEffect(() => {
        if(!isCompany) {
            resetCompanyInputsAndErrors();
        }
    }, [isCompany]);

    useEffect(() => {
        if(isOpen == true) {
            setIsCompany(false);
            resetCompanyInputsAndErrors();
            setErrors([]);
        }
    }, [isOpen]);

    return (
        <Modal isOpen={isOpen} onClose={onClose} size="lg">
            <ModalOverlay />
            <ModalContent>
            <ModalHeader>Create Customer {isCompany ? '(Company)' : ''} Account</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
                <form onSubmit={postCustomers}>

                    <FormControl display="flex" alignItems="center" marginBottom={4}>
                        <FormLabel
                            mb="0"
                            ms="1"
                            fontWeight="normal"
                            >
                            Company
                        </FormLabel>
                        <Switch colorScheme="teal" me="10px" onChange={(e) => setIsCompany(e.target.checked)}/>
                    </FormControl>

                    <FormControl >


                        {/* Company Name */}
                        { isCompany 
                            ? <Box pr="12px">
                                <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                                    Company Name
                                </FormLabel>
                                <Input
                                    id="company-name"
                                    borderRadius="15px"
                                    mb="12px"
                                    fontSize="sm"
                                    type="text"
                                    placeholder="Company Name"
                                    size="md" 
                                    isInvalid={invCompanyName === true}
                                    isRequired={true}
                                    value={companyName} 
                                    onChange={e => setCompanyName(e.target.value)}
                                />
                            </Box>
                            : null
                        }

                        {/* Company Number */}
                        { isCompany 
                            ? <Box pr="12px">
                                <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                                    Company Phone/Mobile
                                </FormLabel>
                                <Input
                                    id="company-number"
                                    borderRadius="15px"
                                    mb="12px"
                                    fontSize="sm"
                                    type="text"
                                    placeholder="Company Phone/Mobile"
                                    size="md" 
                                    isInvalid={invCompanyNumber === true}
                                    isRequired={true}
                                    value={companyNumber} 
                                    onChange={e => setCompanyNumber(e.target.value)}
                                />
                            </Box>
                            : null
                        }

                        {/* Company Address */}
                        { isCompany 
                            ? <Box pr="12px">
                                <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                                    Company Address
                                </FormLabel>
                                <Input
                                    id="company-address"
                                    borderRadius="15px"
                                    mb="12px"
                                    fontSize="sm"
                                    type="text"
                                    placeholder="Address"
                                    size="md" 
                                    isInvalid={invCompanyAddress === true}
                                    isRequired={true}
                                    value={companyAddress} 
                                    onChange={e => setCompanyAddress(e.target.value)}
                                />
                            </Box>
                            : null
                        }

                        {/* Company TIN */}
                        { isCompany 
                            ? <Box pr="12px">
                                <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                                    TIN
                                </FormLabel>
                                <Input
                                    id="company-tin"
                                    borderRadius="15px"
                                    mb="12px"
                                    fontSize="sm"
                                    type="text"
                                    placeholder="TIN"
                                    size="md" 
                                    isInvalid={invCompanyTin === true}
                                    isRequired={true}
                                    value={companyTin} 
                                    onChange={e => setCompanyTin(e.target.value)}
                                />
                            </Box>
                            : null
                        }

                        { isCompany 
                            ?  
                            <Text fontSize="sm" color="gray.400" fontWeight="bold" marginTop={4}>
                                CREDENTIALS
                            </Text>
                            : null
                        }

                        <Flex w="100%"
                            flexDirection={{
                            sm: "row",
                            md: "row",
                            }} 
                            alignItems={{ xl: "center" }}>
                            
                            {/* FirstName */}
                            <Box pr="12px">
                                <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                                    {isCompany ? 'Contact' : ''} First Name
                                </FormLabel>
                                <Input
                                    borderRadius="15px"
                                    mb="12px"
                                    fontSize="sm"
                                    type="text"
                                    placeholder="First Name"
                                    size="md" 
                                    isInvalid={invFirstName === true}
                                    isRequired={true}
                                    value={firstName} 
                                    onChange={e => setFirstName(e.target.value)}
                                />
                            </Box>
                            

                            {/* LastName */}
                            <Box pr="12px">
                                <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                                    {isCompany ? 'Contact' : ''} Last Name
                                </FormLabel>
                                <Input
                                    borderRadius="15px"
                                    mb="12px"
                                    fontSize="sm"
                                    type="text"
                                    placeholder="Last Name"
                                    size="md" 
                                    isInvalid={invLastName === true}
                                    isRequired={true}
                                    value={lastName} 
                                    onChange={e => setLastName(e.target.value)}
                                />
                            </Box>

                        </Flex>

                        {/* Gender */}
                        <FormLabel as="legend">Gender</FormLabel>
                        <RadioGroup 
                            defaultValue="Male" mb="12px" 
                            onChange={setGender}
                            value={gender}
                        >
                            <HStack spacing="24px">
                                <Radio value="Male">Male</Radio>
                                <Radio value="Female">Female</Radio>
                            </HStack>
                        </RadioGroup>

                        {/* Mobile */}
                        <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                            {isCompany ? 'Contact' : ''} Mobile Number
                        </FormLabel>
                        <Input
                            borderRadius="15px"
                            mb="12px"
                            fontSize="sm"
                            type="text"
                            placeholder="09xxxxxxxxx"
                            size="md" 
                            isInvalid={invMobile === true}
                            isRequired={true}
                            value={mobile} 
                            onChange={e => setMobile(e.target.value)}
                        />
                        
                        {/* Email */}
                        <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                            Email
                        </FormLabel>
                        <Input
                            borderRadius="15px"
                            mb="12px"
                            fontSize="sm"
                            type="text"
                            placeholder="Enter Email Address"
                            size="md" 
                            isInvalid={invEmail === true}
                            isRequired={true}
                            value={email} 
                            onChange={e => setEmail(e.target.value)}
                        />

                        {/* Password */}
                        <FormLabel ms="4px" fontSize="sm" fontWeight="normal">
                            Password
                        </FormLabel>
                        <Input
                            borderRadius="15px"
                            mb="36px"
                            fontSize="sm"
                            type="password"
                            placeholder="Enter Customer Password"
                            size="md"
                            isInvalid={invPassword === true}
                            isRequired={true}
                            value={password} 
                            onChange={e => setPassword(e.target.value)}
                        />

                        <Flex w="100%" flexDir="column">
                            { errors.length > 0 && <Text color="red">{errors[0]}</Text> }
                        </Flex>
                        <Button
                            fontSize="10px"
                            type="submit"
                            bg="teal.300"
                            w="100%"
                            h="45"
                            mb="20px"
                            color="white"
                            mt="0px"
                            _hover={{
                            bg: "teal.200",
                            }}
                            _active={{
                            bg: "teal.400",
                            }}
                            isDisabled={submitting}
                        >
                            SUBMIT
                        </Button>
                    </FormControl>
                </form>
            </ModalBody>
            {/* <ModalFooter>
                <Flex w="100%"
                flexDirection={{
                sm: "row",
                md: "row",
                }} 
                alignItems={{ xl: "center" }}>
                <Button variant="ghost" onClick={onClose}>Cancel</Button>
                <Spacer />
                <Button colorScheme="teal" mr={3} >
                    Submit
                </Button>
                </Flex>
            </ModalFooter> */}
            </ModalContent>
        </Modal>
    );

}



export default CreateCustomer;
